export default __webpack_public_path__ + "static/Greycliffcf-extrabold-webfont-18759babecea5636ca829c759541033a.woff2";